import { TOOLTIP_DEFAULT_OFFSET_X, TOOLTIP_DEFAULT_OFFSET_Y } from "shared/utils/styleConstants";
import { TooltipProps, TooltipVariant } from "./tooltip.type";
import classNames from "classnames";
import Size from "shared/enums/Size";
import { usePopperTooltip } from "react-popper-tooltip";
import React from "react";
import TooltipPortal from "./components/tooltipPortal";
import Variant from "shared/enums/Variant";

function getClassNames(className?: string, variant?: TooltipVariant, size?: Size) {
  return classNames(className, {
    toolTip_icon: true,
    "toolTip_icon--default": true,
    [`toolTip_icon--${variant}`]: variant,
    [`toolTip_icon--${size}`]: size
  });
}

function getOverlayClassNames(
  overlayClassName?: string,
  variant?: TooltipVariant,
  stylizedDark?: boolean,
  stylizedInfo?: boolean
) {
  return classNames(overlayClassName, {
    tooltipContainer: true,
    "tooltip-container": true, //required by library for basic styles
    [`tooltip--${variant}`]: variant,
    "stylized--dark": stylizedDark, //todo: ANS - Refactor as variant
    "stylized--info": stylizedInfo //todo: ANS - Refactor as variant
  });
}

export default function useTooltipService({
  interactive = true,
  variant = Variant.PRIMARY,
  size = Size.MEDIUM,
  offSetX = TOOLTIP_DEFAULT_OFFSET_X, // Use this prop if you want to move the tooltip horizontally
  offSetY = TOOLTIP_DEFAULT_OFFSET_Y, // Use this prop if you want to move the tooltip vertically
  ...props
}: TooltipProps) {
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    interactive: interactive,
    trigger: props.trigger,
    placement: props.placement,
    offset: [offSetX, offSetY],
    defaultVisible: props.defaultVisible,
    delayHide: 100
  });

  const computedClassNames = React.useMemo(
    () => getClassNames(props.className, variant, size),
    [props.className, variant, size]
  );
  const computedOverlayClassNames = React.useMemo(
    () => getOverlayClassNames(props.overlayClassName, variant, props?.stylizedDark, props?.stylizedInfo),
    [props.overlayClassName, props?.stylizedDark, props?.stylizedInfo, variant]
  );

  const tooltipPortal = React.useMemo(() => {
    return visible ? (
      <TooltipPortal
        getArrowProps={getArrowProps}
        getTooltipProps={getTooltipProps}
        setTooltipRef={setTooltipRef}
        isHTMLFormatted={props.isHTMLFormatted}
        content={props.content}
        animated={props.animated}
        overlayClassName={computedOverlayClassNames}
        tooltipClass={props.tooltipClass}
        size={size}
      />
    ) : null;
  }, [
    computedOverlayClassNames,
    getArrowProps,
    getTooltipProps,
    props.animated,
    props.content,
    props.isHTMLFormatted,
    props.tooltipClass,
    setTooltipRef,
    size,
    visible
  ]);

  return {
    setTriggerRef,
    computedClassNames,
    visible,
    tooltipPortal
  };
}
